import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class AccessTokens extends CommonCRUD {}

export default AccessTokens;
